<script>
import Layout from '@layouts/main'
import WarehouseDeviceTable from './components/warehouse-devices-table'

export default {
  name: 'Warehouse',
  metaInfo: {
    title: 'Warehouse',
    meta: [{ name: 'description', content: 'Warehouse' }],
  },
  components: {
    Layout,
    WarehouseDeviceTable,
  },
  data: () => ({
    warehouseId: null,
    componentKey: 0,
  }),
  created() {
    this.warehouseId = this.$route.params.id
    // this.prepareFilters()
    // this.getPaginator()
    // this.fetchData()
  },
  methods: {
    forceRerender() {
      this.componentKey += 1
    },
    onDataUpdatedHandler() {
      this.forceRerender()
    },
  },
}
</script>
<template>
  <Layout>
    <WarehouseDeviceTable
      :warehouse-id="warehouseId"
      @data-updated="onDataUpdatedHandler"/>
  </Layout>
</template>
